import axios from "axios";
import { RESET_PASSWORD_FAILURE, RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS, SEND_OTP_FAILURE, SEND_OTP_REQUEST, SEND_OTP_SUCCESS, VERIFY_OTP_FAILURE, VERIFY_OTP_REQUEST, VERIFY_OTP_SUCCESS } from "./actionTypes";

export const sendOtp = (payload) => (dispatch) => {
    dispatch({
        type: SEND_OTP_REQUEST,
        payload: true
    })
    return axios.post("http://54.206.125.24:8888/api/v1/auth/send-otp", payload)
        .then((r) => {
            console.log(r);
            dispatch({
                type: SEND_OTP_SUCCESS,
                payload: r.data
            })
            return r.data;
        })
        .catch((err) => {
            console.log(err.message);
            dispatch({
                type: SEND_OTP_FAILURE,
                payload: true
            })
        })
}

export const verifyOtp = (payload) => (dispatch) => {
    dispatch({
        type: VERIFY_OTP_REQUEST,
        payload: true
    })
    return axios.post("http://54.206.125.24:8888/api/v1/auth/verify-otp", payload)
        .then((r) => {
            console.log(r);
            dispatch({
                type: VERIFY_OTP_SUCCESS,
                payload: r.data
            })
            return r.data;
        })
        .catch((err) => {
            console.log(err.message);
            dispatch({
                type: VERIFY_OTP_FAILURE,
                payload: true
            })
        })
}

export const resetPassword = (payload) => (dispatch) => {
    dispatch({ type: RESET_PASSWORD_REQUEST });
    return axios({
        method: "post",
        url: "/api/v1/auth/updatepassword",
        baseURL: "http://54.206.125.24:8888",
        data: payload
    })
        .then((res) => {
            console.log(res);
            dispatch({ type: RESET_PASSWORD_SUCCESS, payload: res.data })
            return res.data;
        })
        .catch((err) => {
            dispatch({ type: RESET_PASSWORD_FAILURE, payload: err })
        })
}